import React, { useEffect, useState } from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import ParentChildItem from "./ParentChildItem";
import axios from "../../../axios";
import { toast } from "react-toastify";
import { NoContent } from "../../UI";

export default function ParentViewModal({ data, show, handleClose }) {
  const authToken = localStorage.getItem("access_token");
  const [guardianChildren, setGuardianChidlren] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/guardian-children/${data.userId}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setGuardianChidlren(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Couldn't load children");
        setIsLoading(false);
      });
  }, []);

  return (
    <Modal
      show={show}
      size="lg"
      onHide={handleClose}
      centered
      className="parent-view-modal max-heighted-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Parent Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className="custom-scrollbar">
        <Tabs defaultActiveKey="parent" className="mb-3">
          <Tab eventKey="parent" title="Parent" className="p-3">
            <div className="row g-0">
              <div className="col-md-4">
                <p className="label-heading">Name</p>
                <p>{data.firstName + " " + data.lastName}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Email</p>
                <p>{data.email}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Phone 1</p>
                <p>{data.guardianPhone1}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Phone 2</p>
                <p>{data.guardianPhone2}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Address</p>
                <p className="mb-0">{data.guardianAddress1}</p>
                <p>{data.guardianAddress2}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">City</p>
                <p>{data.guardianCity}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Postcode</p>
                <p>{data.guardianPostcode}</p>
              </div>
            </div>
          </Tab>
          <Tab eventKey="emergency" title="Emergency" className="p-3">
            <div className="row g-0">
              <div className="col-md-4">
                <p className="label-heading">Name</p>
                <p>{data.emergencyFirstName + " " + data.emergencyLastName}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Phone</p>
                <p>{data.emergencyPhone}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Relation with child</p>
                <p>{data.emergencyRelation}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Address</p>
                <p className="mb-0">{data.emergencyAddress1}</p>
                <p>{data.emergencyAddress2}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">City</p>
                <p>{data.emergencyCity}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Postcode</p>
                <p>{data.emergencyPostcode}</p>
              </div>
            </div>
          </Tab>
          <Tab eventKey="doctor" title="Doctor" className="p-3">
            <div className="row g-0">
              <div className="col-md-4">
                <p className="label-heading">Name</p>
                <p>{data.doctorName}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Telephone</p>
                <p>{data.doctorPhone}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Address</p>
                <p className="mb-0">{data.doctorAddress1}</p>
                <p>{data.doctorAddress2}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">City</p>
                <p>{data.doctorCity}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Postcode</p>
                <p>{data.doctorPostcode}</p>
              </div>
            </div>
          </Tab>
          <Tab eventKey="other" title="Other" className="p-3">
            <div className="row g-0">
              <div className="col-md-4 mb-3">
                <p className="label-heading">Promotions Allowed</p>
                <p className="mb-0">
                  {data.otherPromotionals !== ""
                    ? data.otherPromotionals
                    : "N/A"}
                </p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Precautions for Home</p>
                <p>
                  {data.otherPrecautions !== "" ? data.otherPrecautions : "N/A"}
                </p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Internet Access</p>
                <p className="mb-0">{data.otherInternetAccess}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Lead Source</p>
                <p>{data.otherLeadSource}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Volunteer</p>
                <p>{data.otherVolunteer}</p>
              </div>
              <div className="col-md-4">
                <p className="label-heading">Ethnic Background</p>
                <p>{data.otherEthnicity}</p>
              </div>
            </div>
          </Tab>
        </Tabs>
        <div className="list-table table-responsive custom-scrollbar mt-3">
          <table className="table align-middle mb-0 table-borderless">
            <thead className="primary-button fw-bold">
              <tr>
                <td>Sr No.</td>
                <td>Child Name</td>
                <td>Date of Birth</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              {guardianChildren.length ? (
                guardianChildren.map((item, index) => {
                  return (
                    <ParentChildItem
                      key={item.childId}
                      data={item}
                      srNo={index + 1}
                    />
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4}>
                    <NoContent />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
}
